import { render, staticRenderFns } from "./LandingLloyds.vue?vue&type=template&id=4d4e87b0&"
import script from "./LandingLloyds.vue?vue&type=script&lang=js&"
export * from "./LandingLloyds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports